export type BillingSignal =
    | {type: 'ready-to-bill'}
    | {type: 'accruing'}
    | {type: 'awaiting-quickbooks'}
    | {type: 'fully-billed'}
    | {type: 'none'}

export type BillingSignalInput = {
    unbilledCount: number
    unbilledTotal: number
    unbilledOnDraftTotal: number
    billedOutCount: number
    plannedCount: number
    activeCount: number
}

/**
 * Derives the project card's billing verdict from aggregate fields already on the row.
 *
 * Evaluated in spec order: awaiting-quickbooks is checked before the open-jobs split
 * because recording the QuickBooks number is the right action whether or not jobs
 * are still running.
 */
export function deriveBillingSignal(project: BillingSignalInput): BillingSignal {
    const {
        unbilledCount,
        unbilledTotal,
        unbilledOnDraftTotal,
        billedOutCount,
        plannedCount,
        activeCount,
    } = project

    if (unbilledCount > 0) {
        if (unbilledOnDraftTotal === unbilledTotal) {
            return {type: 'awaiting-quickbooks'}
        }
        const openJobCount = plannedCount + activeCount
        return openJobCount === 0 ? {type: 'ready-to-bill'} : {type: 'accruing'}
    }

    return billedOutCount > 0 ? {type: 'fully-billed'} : {type: 'none'}
}

/** Whole days elapsed since `oldestUnbilledAt`, floored, never negative. */
export function ageInDays(oldestUnbilledAt: string, now: Date = new Date()): number {
    const from = new Date(oldestUnbilledAt)
    const diffMs = now.getTime() - from.getTime()
    return Math.max(0, Math.floor(diffMs / (1000 * 60 * 60 * 24)))
}
